//gsap
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

export const blueStairsAnimation = () => {
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".tenesys-block-stairs-animation")) {
      let stairsBlocks = gsap.utils.toArray(".tenesys-block-stairs-animation");

      stairsBlocks.forEach((stairsBlock) => {
        let stairOne = stairsBlock.querySelector(
          ".tenesys-stair-one .kt-inside-inner-col",
        );
        let stairTwo = stairsBlock.querySelector(
          ".tenesys-stair-two .kt-inside-inner-col",
        );
        let stairThree = stairsBlock.querySelector(
          ".tenesys-stair-three .kt-inside-inner-col",
        );
        let stairsAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: stairsBlock,
            start: "top 70%",
            scrub: 1,
            end: "top 40%",
            toggleActions: "play none none reverse",
          },
          defaults: { ease: "none", duration: 0.6 },
        });
        stairsAnimation
          .to(stairOne, {
            height: 40,
          })
          .to(
            stairTwo,
            {
              height: 80,
            },
            "<",
          )
          .to(
            stairThree,
            {
              height: 120,
            },
            "<",
          );
      });
    }
  });
};
